// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-3ogqJ","button":"button-cfRaF","price":"price-13OgU"};